import { PLAN_STATUS, PricingPlan } from '../../consts/enums';
import { AccountsTrialPlan } from '../../pages/AccountsPage/AccountsTable/AccountsTrialPlan';
import { AccountPlan } from '../../@types/Account';

type AccountPricingPlanProps = {
  // eslint-disable-next-line react/require-default-props
  accountPlan?: AccountPlan,
}

export default function AccountPricingPlan({
  accountPlan,
}:AccountPricingPlanProps): JSX.Element {
  if (accountPlan !== undefined) {
    let plan = '';
    const isPlanEnded = accountPlan.endDate ? (new Date() > new Date(accountPlan.endDate)) : false;

    const { displayName, pricingPlan } = accountPlan.planDefinition;

    if (isPlanEnded && pricingPlan === PricingPlan.Trial) {
      plan = PLAN_STATUS.TRIAL_ENDED;
    }
    if (!isPlanEnded && pricingPlan === PricingPlan.Trial) {
      plan = PLAN_STATUS.TRIAL;
    }
    if (accountPlan.planDefinition?.isPaidPlan) {
      plan = PLAN_STATUS.PAID;
    }
    if (isPlanEnded && pricingPlan !== PricingPlan.Trial) {
      plan = PLAN_STATUS.CANCELED;
    }
    if (pricingPlan === PricingPlan.Lite) {
      plan = PLAN_STATUS.LITE;
    }

    return (
      <AccountsTrialPlan
        plan={ plan }
        planDisplayName={ displayName }
      />
    );
  }
  
  return <></>;
}
